import {
  ON_START_USER_ATTEMPT_MORE_5,ON_USER_ATTEMPT_MORE_5,
  FETCH_ERROR,MY_IPADDRESS,ON_GET_SETTING_INITIAL_AVTAL,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  SHOW_MESSAGE,
  USER_TOKEN_SET,
  HIDE_MESSAGE,
  UPDATE_MY_USER,
  UPDATE_THIS_USER,
  FETCH_START_GET_USER,
  FETCH_ERROR_GET_USER,
  SET_ZERO_KUND,
  SET_ZERO_AVTAL,SET_ZERO_PROSPEKT,
  SET_ZERO_ORDER,
  SET_ZERO_EVENT,
  SET_ZERO_INTRANET,
  SET_ZERO_OFFER,
  SET_ZERO_AKTIVITET,
  SET_ZERO_USER,
  SET_ZERO_AUTHENTICATION,
  FETCH_VALIDATION_SUCCESS,
  FETCH_TOKEN_EXPIR,
  SET_ZERO_DASHBOARD,
  SET_ZERO_ESIGNERING,FETCH_START_INTERFACE,
  SET_ZERO_ARENDE,
  SET_ZERO_PROJECT,
  SET_ZERO_OFFERT,
  SET_ZERO_DIALER,UNSET_AVTALVY_TYPE,UNSET_ORDERVY_TYPE,UNSET_EVENTVY_TYPE,
  FETCH_START_FORGET_PASS,FETCH_FORGET_PASS,FETCH_FORGET_PASS_ERROR,
  FETCH_START_UPDATE_PASS,FETCH_UPDATE_PASS,FETCH_UPDATE_PASS_ERROR,GET_USER_PROFILE_PIC,
  UNSET_ESIGNVY_TYPE,UNSET_ARTIKLARVY_TYPE,
  SET_AKTIVITETER_FILTER,SET_ARENDE_FILTER,SET_AVTAL_FILTER,SET_ESIGNERING_FILTER,SET_EVENT_FILTER,
  SET_KUNDER_FILTER,SET_OFFERT_FILTER,SET_ORDER_FILTER,SET_PROSPEKT_FILTER, SET_PROJEKT_FILTER,
  FETCH_START_CHECK_USER_PASS,CHECK_USER_PASS,FETCH_ERROR_CHECK_USER_PASS,
  FETCH_START_SET_AUTHE,
  FETCH_START_SET_UNAUTHE,
  ON_START_GET_USER_LOGIN_HISTORY,
  ON_ERROR_GET_USER_LOGIN_HISTORY,
  ON_GET_USER_LOGIN_HISTORY,
} from "../constants/ActionTypes";
import axios from 'util/Api';
import setAuthorizationToken from '../util/setAuthorizationToken';
import jwtDecode from 'jwt-decode';
import { history } from "store";
import { isUndefined } from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { translate } from "../util/intlHelper";
import moment from "moment";
import {encrypt,decrypt} from 'actions'
//import moment from 'moment-timezone'

export const VersionCheck = async (refresh = 0) => {
    try {
      const response = await fetch('/public/version.json');
      if (!response.ok) {
        return;
      }

      const data = await response.json();
      const currentVersion = localStorage.getItem('appVersion');
      if (currentVersion && currentVersion !== data.version) {
        console.log("Version mismatch detected. Current:", currentVersion, "New:", data.version);

        if (refresh === 1) {
          console.log("Refreshing page due to version change...");
          localStorage.setItem('appVersion', data.version);
          window.location.reload(true);
        }
      } 
    } catch (error) {
      console.error("Error checking version:", error);
    }
};



let Ipadress = '0.0.0.0'
export const getClientIp = async () => {
  Ipadress='0.0.0.0'
  try{
    await fetch('https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.IPv4 
    });
  }catch(error){
    Ipadress='0.0.0.0'
  }
  console.log(Ipadress)
  return Ipadress  
}

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};
export const showAuthMessage = (message) => {
  return {
      type: SHOW_MESSAGE,
      payload: message
  };
};


function setDefaultFilter (token) {
  return (dispatch) => {
    try {
      let user = jwtDecode(token)
      dispatch(onRefeshOutlookToken(user.user_id,user.user_Afid))
      if(parseInt(user.user_DFilterAllaAktivitet) === 1) dispatch({type:SET_AKTIVITETER_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaAktivitet) === 2) dispatch({type:SET_AKTIVITETER_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaArande) === 1) dispatch({type:SET_ARENDE_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaArande) === 2) dispatch({type:SET_ARENDE_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaAvtal) === 1) dispatch({type:SET_AVTAL_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaAvtal) === 2) dispatch({type:SET_AVTAL_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaEsignering) === 1) dispatch({type:SET_ESIGNERING_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaEsignering) === 2) dispatch({type:SET_ESIGNERING_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaEvent) === 1) dispatch({type:SET_EVENT_FILTER,payload:[{Meta:parseInt(user.user_role) === 4?"EventBokadAv":"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaEvent) === 2) dispatch({type:SET_EVENT_FILTER,payload:[{Meta:parseInt(user.user_role) === 4?"EventBokadAv":"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaKunder) === 1) dispatch({type:SET_KUNDER_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaKunder) === 2) dispatch({type:SET_KUNDER_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaOffert) === 1) dispatch({type:SET_OFFERT_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaOffert) === 2) dispatch({type:SET_OFFERT_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaOrder) === 1) dispatch({type:SET_ORDER_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaOrder) === 2) dispatch({type:SET_ORDER_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaProspekt) === 1) dispatch({type:SET_PROSPEKT_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaProspekt) === 2) dispatch({type:SET_PROSPEKT_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      if(parseInt(user.user_DFilterAllaProjekt) === 1) dispatch({type:SET_PROJEKT_FILTER,payload:[{Meta:"ansvarig",Value:"-1"}]})
      if(parseInt(user.user_DFilterAllaProjekt) === 2) dispatch({type:SET_PROJEKT_FILTER,payload:[{Meta:"ansvarig",Value:"-2"}]})
      
    } catch (err) {
      console.log(err)
    }
  }
}

export function setCurrentUser(token) {
  //console.log(jwtDecode(token),"TTOKN")
  try{
    if(parseInt(jwtDecode(token).user_id)===6 || parseInt(jwtDecode(token).user_kanVaxla)===1){      
      localStorage.setItem("SPa", uuidv4());
    }
  }catch(error){
    console.log(error)
  }
  return {
    type: USER_TOKEN_SET,
    token:token,
    user:jwtDecode(token)
  }
}
//


//
export function setCurrentMyUser(data) {
  return {
   type: UPDATE_MY_USER,
   token:data.token,
   user:jwtDecode(data.token),
   CurrentUSer:data.user
 }
}

export function checkisExpired(token) {
  // console.log(token)
 // console.log(Date.now(new Date().toUTCString()))
 // console.log(Date.now())
 // console.log(moment(Date.now()))
 // console.log(moment(Date.now(new Date().toUTCString())))
 // console.log(Date.now()/1000)
 // console.log(Date.now(new Date().toUTCString())/1000)
 // console.log(jwtDecode(token).exp)
  return (dispatch) => {
    let exp = jwtDecode(token).exp;
    /*
    console.log(exp,"Exppppppp")
    console.log(Date.now(),"Exppppppp")    
    console.log(moment(Date.now()),"Exppppppp")
    console.log(moment(new Date().toUTCString()),"Exppppppp")
    console.log(moment(new Date()).utcOffset(0, true),"Exppppppp1")
    console.log(moment.tz.guess(),"Exppppppp")
    console.log(Date.now(new Date().toUTCString())/ 1000,"Exppppppp")
    console.log(Date.now(moment(new Date()).utcOffset(0, true))/ 1000,"Exppppppp")
    */
   //
   //let exp2 = 1734536000 
   console.log(exp,"currentVersion")
   console.log(Date.now(new Date().toUTCString())/ 1000,"currentVersion")
   //console.log(exp2,"currentVersion")
   
  if (!exp) {
    dispatch({type: FETCH_TOKEN_EXPIR,payload:true});
  }
  else if( Date.now(new Date().toUTCString())/ 1000 > exp){
    console.log("DDDDD","currentVersion")
    dispatch({type: FETCH_TOKEN_EXPIR,payload:true});
  }
  else{
    dispatch({type: FETCH_TOKEN_EXPIR,payload:false});
  }
     
   }
  
}


export const userResetPasswrd = ({email, Orgnr}) => {
  return async (dispatch) => {
    const ipAdress=await getClientIp()
    dispatch({type: FETCH_START_FORGET_PASS});
    axios.post('users/ForgetPw', encrypt(JSON.stringify({
        "email": email,
        "Orgnr": Orgnr,ipAdress
      }))
    ).then( data => {
      console.log("userResetPasswrd: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("userResetPasswrd1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_FORGET_PASS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("userResetPasswrd2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_FORGET_PASS_ERROR, payload: ndate.error});
      }
      
    }).catch(function (error) {
      dispatch({type: FETCH_FORGET_PASS_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};
export const userUpdatePasswrd = ({email, Orgnr,password,Token}) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START_UPDATE_PASS});
    axios.post('users/UpdatePw', encrypt(JSON.stringify({
        "email": email,
        "Orgnr": Orgnr,
        "password": password,
        "Token": Token,ipAdress
      }))
    ).then( data => {
      console.log("userUpdatePasswrd: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("userUpdatePasswrd1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_UPDATE_PASS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("userUpdatePasswrd2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_UPDATE_PASS_ERROR, payload: ndate.error});
      }
     
    }).catch(function (error) {
      dispatch({type: FETCH_UPDATE_PASS_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};



export const userSignIn = ({email, password}) => {
  return async (dispatch,getState) => {
    //const ipAdress=await getClientIp()
    const {IpAdress} = getState().auth;
    dispatch({type: FETCH_START});
    axios.post('users/login', encrypt(JSON.stringify({
        "UserEmail": email,
        "UserPass": password,
        "ipAdress": IpAdress,
        "RfTok": 0,
      }))
    ).then( data => {
      console.log("userSignIn: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("userSignIn1: ", endata);
        let ndate = JSON.parse(endata)
        console.log("userSignIn2: ", ndate);
        if(isUndefined(ndate.ToValidation)){
          if (data.data.success) {
            if(isUndefined(ndate.inactive)){
              console.log(parseInt(JSON.stringify(ndate.token).user_Token))
              localStorage.setItem("token", JSON.stringify(ndate.token));
              setAuthorizationToken(JSON.stringify(ndate.token));
              dispatch({type: ON_START_USER_ATTEMPT_MORE_5});
              dispatch(setCurrentUser(ndate.token));  
              dispatch({type:ON_GET_SETTING_INITIAL_AVTAL,payload:jwtDecode(ndate.token)})
              dispatch(setDefaultFilter(ndate.token));  
              history.push({
                pathname: `/`,
              })
              VersionCheck(1);
            }
            if(data.inactive === true){
              dispatch({type: FETCH_SUCCESS});
              history.push({
                pathname: `/inactive`,
              })
            }
            else{
              //
              dispatch({type: HIDE_MESSAGE});
              dispatch({type: ON_USER_ATTEMPT_MORE_5,payload: ndate});
            }
          }
          else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            console.log("getEsigneringHistory2: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: FETCH_ERROR, payload: ndate.error});
          }
        }else{
          dispatch({type: FETCH_VALIDATION_SUCCESS, payload: ndate});
          dispatch({type: FETCH_SUCCESS});
          history.push({
            pathname: `/Validation/${encodeURIComponent(ndate.Token)}`,
        })
        }
      }
      else{
        dispatch({type: FETCH_ERROR, payload: translate("Action.InvalidEmailPass")});
      }





// 
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: translate("Action.InvalidEmailPass")});
      console.log("Error****:", error);
    });
  }
};
//checkThisEmail

export const checkThisEmail = (Email)=>{
  return async (dispatch) => {
    dispatch({type: ON_START_USER_ATTEMPT_MORE_5});
    axios.post('users/e/Check', encrypt(JSON.stringify({
      "Email": Email
    }))
  ).then( data => {
    console.log("checkThisEmail: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("checkThisEmail1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: FETCH_SUCCESS});
      dispatch({type: ON_USER_ATTEMPT_MORE_5,payload: ndate});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("checkThisEmail2: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: FETCH_ERROR, payload: ndate.error});
    }
  }).catch(function (error) {
    dispatch({type: FETCH_ERROR, payload: error.message});
     console.log("Error****:", error.message);
   });
  }
}
//resendAvlidation
export const resendAvlidation = (Token) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START});
    axios.post('users/login/ReValidate', encrypt(JSON.stringify({
        "Token": String(Token),
        "ipAdress": ipAdress,
      }))
    ).then( data => {
      console.log("userSignIn: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("resendAvlidation1: ", endata);
        let ndate = JSON.parse(endata)
        if(ndate.ToValidation){
          dispatch({type: FETCH_VALIDATION_SUCCESS, payload: ndate});
          dispatch({type: FETCH_SUCCESS});
        }else{
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: FETCH_VALIDATION_SUCCESS, payload: ndate});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("resendAvlidation2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    }).catch(function (error) {
     dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};
//ValidateAccount
export const ValidateAccount = (Token, Secret) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: FETCH_START});
    axios.post('users/login/Validate', encrypt(JSON.stringify({
        "Token": Token,
        "Secret": Secret,ipAdress
      }))
    ).then( data => {
      console.log("alidateAccount: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("V1: ", endata);
        let ndate = JSON.parse(endata)
        if(ndate.token){
          localStorage.setItem("token", JSON.stringify(ndate.token));
          setAuthorizationToken(JSON.stringify(ndate.token));
          dispatch(setCurrentUser(ndate.token)); 
          dispatch(setDefaultFilter(ndate.token));  
           
          history.push({
            pathname: '/app/Lobby',
          })
        }else{
          dispatch({type: FETCH_ERROR, payload:  translate("Action.InvalidCode")});
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("ValidateAccount2: ", endata);
        dispatch({type: FETCH_ERROR, payload:  translate("Action.InvalidCode")});
      }
    }).catch(function (error) {
     dispatch({type: FETCH_ERROR, payload: translate("Action.InvalidCode")});
      console.log("Error****:", error.message);
    });
  }
};
//userRefreshToken
export const userRefreshToken = ({email, password}) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START});
    axios.post('users/login', encrypt(JSON.stringify({
        "UserEmail": email,
        "UserPass": password,
        "ipAdress": ipAdress,
        "RfTok": 1,
      }))
    ).then( data => {
      console.log("userSignIn: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("userRefreshToken1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_TOKEN_EXPIR,payload:false});
        localStorage.setItem("token", JSON.stringify(ndate.token));
        setAuthorizationToken(JSON.stringify(ndate.token));
        //console.log(1)
        dispatch(setCurrentUser(ndate.token)); 
        let user = jwtDecode(ndate.token)
        dispatch(onRefeshOutlookToken(user.user_id,user.user_Afid)) 
        VersionCheck(1); 
        // dispatch(setDefaultFilter(data.token));  

      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("userRefreshToken: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_TOKEN_EXPIR,payload:true});
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
      
    }).catch(function (error) {
      dispatch({type: FETCH_TOKEN_EXPIR,payload:true});
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};
//
export const getMyUser = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
   dispatch({type: FETCH_START_GET_USER});
    axios.get('users/getUser', { params:encrypt(JSON.stringify({ userid:userid,Afid,ipAdress})), headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data => {
      console.log("getUser: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: USER_DATA, payload: ndate.results[0]});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR_GET_USER, payload: ndate.error});
      }
    
    }).catch(function (error) {

      dispatch(GotofirstPage())

      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
      //Ta bort sessiontoken om den inte är valid
      // localStorage.removeItem("token");
      
      if(error.message === "Network Error"){
        //reload and remove token 
        dispatch(userSignOut())
     }
    }); 
  }
}
export const getMyUserLoginHistory = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
   dispatch({type: ON_START_GET_USER_LOGIN_HISTORY});
    axios.get('users/getUserLoginHistory', { params:encrypt(JSON.stringify({userid:userid,Afid,ipAdress})), 
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data => {
      console.log("getUserLoginHistory: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUserLoginHistory1: ", endata);
        let ndate = JSON.parse(endata);
        dispatch({type: ON_GET_USER_LOGIN_HISTORY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUserLoginHistory2: ", endata);
        let ndate = JSON.parse(endata);
        dispatch({type: ON_ERROR_GET_USER_LOGIN_HISTORY, payload: ndate.error});
      }

     
    }).catch(function (error) {
      dispatch(GotofirstPage())
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
      //Ta bort sessiontoken om den inte är valid
      // localStorage.removeItem("token");
      
      if(error.message === "Network Error"){
        //reload and remove token 
        dispatch(userSignOut())
     }
    }); 
  }
}

export const getMyUserProfilePic = (userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.get('users/getProfilePic', { params:encrypt(JSON.stringify({
      Userid:userid,ipAdress
    })), headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data => {
      console.log("getMyUserProfilePic: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMyUserProfilePic1: ", endata);
        let ndate = JSON.parse(endata);
        dispatch({type: GET_USER_PROFILE_PIC, payload: ndate[0]});
      }
    }).catch(function (error) {
      console.log("Error****:", error.message);
    }); 
  }
}
export const updateUser = (user,AuthID) => {
  if(user.UserPass === "" || user.IsChangedUserPass === false){
    delete user.UserPass;
  }
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START_GET_USER});
    axios.put('users/f1', {
      body: encrypt(JSON.stringify({
        user:user,
        AuthID:AuthID,
        ipAdress
      }))
      },{
        headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }

  }).then( data => {
      console.log("updateMyUser: ", data);
      dispatch(RefreshUserInterface(AuthID,1))
      if(data.data.success){
        dispatch({type: FETCH_SUCCESS});
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateMyUser1: ", endata);
        let ndate = JSON.parse(endata)
        if(user.id === parseInt(AuthID)){
          localStorage.setItem("token", JSON.stringify(ndate.token));
          setAuthorizationToken(JSON.stringify(ndate.token));
          dispatch(setCurrentMyUser(ndate)); 
        } else{
          dispatch({type: UPDATE_THIS_USER, payload: ndate});
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateMyUser2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR_GET_USER, payload: ndate.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};
export const checkPassWord = (user,AuthID,password) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START_CHECK_USER_PASS});
    axios.put('users/password/Check', {
      body: encrypt(JSON.stringify({
        user:user,
        AuthID:AuthID,password,ipAdress
      })) },{
      headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${jwt}`
      }
  }).then( data  => {
    console.log("checkPassWord: ", data);
    if(data.data.success){
    let endata = decrypt(data.data.encryptedData,data.data.iv)
    console.log("checkPassWord1: ", endata);
    let ndate = JSON.parse(endata);
    dispatch({type: CHECK_USER_PASS, payload: ndate});
    }else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("checkPassWord2: ", endata);
      let ndate = JSON.parse(endata);
      dispatch({type: FETCH_ERROR_CHECK_USER_PASS, payload: ndate.error});
    }
  })
  .catch(function (error) {
    dispatch({type: FETCH_ERROR, payload: error.message});
  })
  }
}
//onUpdateUserPass
export const onUpdateUserPass = (AuthID,currentPassword,newPassword) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: FETCH_START_GET_USER});
    axios.put('user/update', {
       body: encrypt(JSON.stringify({
        currentPassword:currentPassword,
        newPassword:newPassword,IpAdress
      }))}, {
      headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${jwt}`
      },
     

  }).then( data => {
    console.log("onUpdateUserPass: ", data);
    if(data.data.success){
    let endata = decrypt(data.data.encryptedData,data.data.iv)
    console.log("onUpdateUserPass1: ", endata);
    let ndate = JSON.parse(endata);
    dispatch(RefreshUserInterface(AuthID),1)
    localStorage.setItem("token", JSON.stringify(ndate.token));
    setAuthorizationToken(JSON.stringify(ndate.token));
    dispatch(setCurrentMyUser(ndate)); 
    }
  })
  .catch(function (error) {
    dispatch({type: FETCH_ERROR, payload: error.message});
    console.log("Error****:", error.message);
  });
  }
}
//
export const updateAUser = (user,AuthID) => {
  if(user.UserPass === ""  || user.IsChangedUserPass === false){
    delete user.UserPass;
  }
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    dispatch({type: FETCH_START_GET_USER});
    axios.put('users/Af1', {
      body: encrypt(JSON.stringify({
        user:user,
        AuthID:AuthID,ipAdress
      }))
    }, {
      
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${jwt}`
    },

  }).then( data => {
    console.log("updateMyAUser: ", data);
    if(data.data.success){
      dispatch(RefreshUserInterface(AuthID),1)
      dispatch({type: FETCH_SUCCESS});
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("updateMyAUser1: ", endata);
      let ndate = JSON.parse(endata)
      if(user.id === parseInt(AuthID)){
        localStorage.setItem("token", JSON.stringify(ndate.token));        
        setAuthorizationToken(JSON.stringify(ndate.token));
        dispatch(setCurrentMyUser(data)); 
      }else{
        dispatch({type: UPDATE_THIS_USER, payload: ndate});
      }
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("updateMyAUser2: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: FETCH_ERROR_GET_USER, payload: ndate.error});
    }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};












export const userSignUp = ({name, email, password}) => {
  console.log(name, email, password);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START});
    axios.post('auth/register', {
        email: email,
        password: password,
        name: name,ipAdress
      }
    ).then(({data}) => {
      console.log("data:", data);
      if (data.result) {
        localStorage.setItem("token", JSON.stringify(data.token.access_token));
        axios.defaults.headers.common['access-token'] = "Bearer " + data.token.access_token;
        dispatch({type: FETCH_SUCCESS});
       // dispatch(setCurrentUser(data.token.access_token));
        dispatch({type: USER_TOKEN_SET, payload: data.token.access_token});
        dispatch({type: USER_DATA, payload: data.user});
      } else {
        console.log("payload: data.error", data.error);
        dispatch({type: FETCH_ERROR, payload: "Network Error"});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};

export const GotofirstPage=()=>{
  return (dispatch) => {
   // dispatch({type: SET_ZERO_ORDER})
    history.push({
      pathname: '/app/Lobby',
    })
  }
}
export const setZeroMessageRP = () => {
  return (dispatch) => {
    dispatch({type: FETCH_START_FORGET_PASS});
  }
}






//
export const userSignOut = () => {
  
  return (dispatch) => {
    dispatch({type: FETCH_SUCCESS});
        
        
        localStorage.removeItem("AvtalFilter");
        localStorage.removeItem("ProspektFilter");
        localStorage.removeItem("KunderFilter");
        localStorage.removeItem("EventFilter");
        localStorage.removeItem("EsigneringFilter");
        localStorage.removeItem("DashboardFilter");
        localStorage.removeItem("AktiviterFilter");
        localStorage.removeItem("OffertFilter");
        localStorage.removeItem("ArendeFilter");
        localStorage.removeItem("OrderFilter");
        localStorage.removeItem("DashboardSaljFilter");
        localStorage.removeItem("DashboardAnpassadFilter");
        localStorage.removeItem("DashboardBOKAFilter");
        localStorage.removeItem("DashboardOrderFilter");
        localStorage.removeItem("DashboardBarnFilter");
        localStorage.removeItem("DashboardProspektFilter");
        localStorage.removeItem("DashboardKontorFilter");
        localStorage.removeItem("ProjektFilter");
        localStorage.removeItem("ProjektKortFilter");
        localStorage.removeItem("currentAvtalVYIndex");
        localStorage.removeItem("currentOrderVYIndex");
        localStorage.removeItem("KundPagerows");
        localStorage.removeItem("ProspektSortObj");
        localStorage.removeItem("CampaignFilter");
        
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SIGNOUT_USER_SUCCESS});
        dispatch({type: SET_ZERO_KUND})
        dispatch({type: SET_ZERO_AVTAL})
        dispatch({type: SET_ZERO_PROSPEKT})
        dispatch({type: SET_ZERO_ORDER})
        dispatch({type: SET_ZERO_EVENT})
        dispatch({type: SET_ZERO_INTRANET})
        dispatch({type: SET_ZERO_OFFER})
        dispatch({type: SET_ZERO_AKTIVITET})
        dispatch({type: SET_ZERO_ESIGNERING})
        dispatch({type: SET_ZERO_DASHBOARD})
        dispatch({type: SET_ZERO_ARENDE})
        dispatch({type: SET_ZERO_PROJECT})
        dispatch({type: SET_ZERO_OFFERT})
        dispatch({type: SET_ZERO_DIALER})
        dispatch({type: UNSET_AVTALVY_TYPE})
        dispatch({type: UNSET_ORDERVY_TYPE})
        dispatch({type: UNSET_EVENTVY_TYPE})
        dispatch({type: UNSET_ESIGNVY_TYPE})
        dispatch({type: UNSET_ARTIKLARVY_TYPE})
        //dispatch({type: SET_ZERO_AUTHENTICATION})
        
        //window.location.reload()
        localStorage.removeItem("SPa");
        localStorage.removeItem("token");
       
  /*  dispatch({type: FETCH_START});
    //auth/logout
    axios.post('users/logout',
    ).then(({data}) => {
      if (data.result) {
        dispatch({type: FETCH_SUCCESS});
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SIGNOUT_USER_SUCCESS});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
    */
  }
};

//getThisUserInterface
export const getThisUserInterface = (userid, refresh = 0) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: FETCH_START_SET_AUTHE});
    axios.get('users/getThisInterface', { 
      params:encrypt(JSON.stringify({userid:userid,ipAdress})), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data  => {
      console.log("getThisUserInterface: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getThisUserInterface1: ", endata);
        let ndate = JSON.parse(endata);
        localStorage.setItem("token", JSON.stringify(ndate.token));
        setAuthorizationToken(JSON.stringify(ndate.token));
        dispatch({type:ON_GET_SETTING_INITIAL_AVTAL,payload:jwtDecode(ndate.token)})
        dispatch(setCurrentUser(ndate.token));         
        dispatch(setDefaultFilter(ndate.token)); 
        history.push({
          pathname: '/app/Lobby',
        }) 
        if(refresh === 1){
          setTimeout(() => {
          //  window.location.reload(true);
          }, 3000);
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getThisUserInterface2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}; 

//RefreshUserInterface
/*export const RefreshUserInterface = (userid) => {
  const jwt =  JSON.parse(localStorage.token);
  let TToken = jwtDecode(jwt)
  const currentTime = Date.now() / 1000; // in seconds
  const expiresIn = TToken.exp - currentTime;
  if (expiresIn < 120) {
    console.log("RefreshUserInterface: ", TToken);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      //dispatch({type: FETCH_START});
      axios.get('users/getThisInterface', { 
        params:encrypt(JSON.stringify({userid:userid,ipAdress})), 
        headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then( data  => {
        console.log("RefreshUserInterface: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("RefreshUserInterface1: ", endata);
          let ndate = JSON.parse(endata);
          console.log("RefreshUserInterface21: ", parseInt(TToken.user_id));
          console.log("RefreshUserInterface22: ", parseInt(userid));
          if(parseInt(TToken.user_id) === parseInt(userid) ){
            localStorage.setItem("token", JSON.stringify(ndate.token));
            setAuthorizationToken(ndate.token); 
          }
          else{
            setTimeout(() => {
              window.location.reload(true);
            }, 1500);
          } 
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("RefreshUserInterface2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
  }
  }  
}; 
*/
export const RefreshUserInterface = (userid,update=0) => {
  return async (dispatch) => {
    try {
      const jwt = JSON.parse(localStorage.token);
      const TToken = jwtDecode(jwt);
      const currentTime = Date.now() / 1000; // in seconds
      const expiresIn = TToken.exp - currentTime;

      // Refresh only if token is close to expiration (within 2 minutes)
      console.log("RefreshUserInterface: ", expiresIn,update, TToken.user_id, userid, jwtDecode(jwt).user_id);
      if (expiresIn < 1800 || update === 1) {
        const ipAdress = '0.0.0.0';

        const response = await axios.get('users/getThisInterface', {
          params: encrypt(JSON.stringify({ userid, ipAdress })),
          headers: { Authorization: `Bearer ${jwt}` },
        });

        const data = response.data;

        if (data.success) {
          const endata = decrypt(data.encryptedData, data.iv);
          const ndate = JSON.parse(endata);

          if (parseInt(TToken.user_id) === parseInt(userid)) {
            localStorage.setItem("token", JSON.stringify(ndate.token));
            setAuthorizationToken(JSON.stringify(ndate.token));
          } else {
            setTimeout(() => window.location.reload(true), 1500);
          }
        } else {
          const Data = isUndefined(data.error) ? data : data.error;
          const endata = decrypt(Data.encryptedData, Data.iv);
          const ndate = JSON.parse(endata);
          dispatch({ type: FETCH_ERROR, payload: ndate.error });
        }
      }

    } catch (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    }
  };
};
//getOutLookLogin
export const getOutLookLogin = (userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.put('outlook/Logint', {
      body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        ipAdress
      }))}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
        }
      })
    }
}
//getOutLookLoginNew
export const getOutLookLoginNew = (userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.put('outlook/LogintNew', {
      body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        ipAdress
      }))}, {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
        }
      })
    }
}
//
export const onRefeshOutlookToken = (userid,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.get('users/refresh/outlook', { 
      params:encrypt(JSON.stringify({Afid:Afid,
        userid:userid,ipAdress})), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
    )
    
    }
}
//
export const getClientIp1 = () =>{
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    await fetch('https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708')
    .then(response => response.json())
    .then(data => {
      console.log(data)
      Ipadress= data.IPv4 
      dispatch({type: MY_IPADDRESS, payload: data.IPv4 });
    }).catch(err => {
      Ipadress= '0.0.0.0'
      dispatch({type: MY_IPADDRESS, payload: Ipadress });
    });
  }
}
//getLockedUser
export const getLockedUser = (callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    axios.get('users/Locked', { headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data   => {
      console.log("getLockedUser: ", data); 
      if(data.data.success){ 
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getLockedUser1: ", endata);
        let ndate = JSON.parse(endata);
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      
    }).catch(function (error) {
      console.log("Error****:", error.message);
    }); 
  }
}
//getLockedUser
export const getAllUsers = (callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    axios.get('users/all', { headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data   => {
      console.log("getAllUsers: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAllUsers1: ", endata);
        let ndate = JSON.parse(endata);
        if(callBackFunc){callBackFunc(ndate.results)}
      }
    }).catch(function (error) {
      console.log("Error****:", error.message);
    }); 
  }
}
//
export const getKontoSMSet = (Filter = [],callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    axios.get('kontos/sms/statistic', {
      params:encrypt(JSON.stringify({Filter})),
       headers: { 'Authorization': `Bearer ${jwt}`} 
    }
    ).then( data  => {
      console.log("getKontoSMSet: ", data); 
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getKontoSMSet1: ", endata);
        let ndate = JSON.parse(endata);
        if(callBackFunc){callBackFunc(ndate.results)}
      }
    }).catch(function (error) {
      console.log("Error****:", error.message);
    }); 
  }
}
//onUnLockedUser
export const onUnLockedUser = (AttId,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    axios.put('users/Locked', {
      body: encrypt(JSON.stringify({
        userid:AttId
      }))}, {
       headers: { 'Authorization': `Bearer ${jwt}`} 
    }
    ).then(  data  => {
      console.log("onUnLockedUser: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onUnLockedUser1: ", endata);
        let ndate = JSON.parse(endata);

      if(callBackFunc){callBackFunc(ndate.results)}
      }
    }).catch(function (error) {
      console.log("Error****:", error.message);
    }); 
  }
}


export const changeAccount =(callBackFunc)=>{
  return async (dispatch) => {
    localStorage.removeItem("AvtalFilter");
    localStorage.removeItem("ProspektFilter");
    localStorage.removeItem("KunderFilter");
    localStorage.removeItem("EventFilter");
    localStorage.removeItem("EsigneringFilter");
    localStorage.removeItem("DashboardFilter");
    localStorage.removeItem("AktiviterFilter");
    localStorage.removeItem("OffertFilter");
    localStorage.removeItem("ArendeFilter");
    localStorage.removeItem("OrderFilter");
    localStorage.removeItem("DashboardSaljFilter");
    localStorage.removeItem("DashboardAnpassadFilter");
    localStorage.removeItem("DashboardBOKAFilter");
    localStorage.removeItem("DashboardOrderFilter");
    localStorage.removeItem("DashboardBarnFilter");
    localStorage.removeItem("DashboardProspektFilter");
    localStorage.removeItem("DashboardKontorFilter");
    localStorage.removeItem("ProjektFilter");
    localStorage.removeItem("ProjektKortFilter");
    localStorage.removeItem("currentAvtalVYIndex");
    localStorage.removeItem("currentOrderVYIndex");
    localStorage.removeItem("KundPagerows");
    localStorage.removeItem("ProspektSortObj");

    dispatch({type: SET_ZERO_KUND})
    dispatch({type: SET_ZERO_AVTAL})
    dispatch({type: SET_ZERO_PROSPEKT})
    dispatch({type: SET_ZERO_ORDER})
    dispatch({type: SET_ZERO_EVENT})
    dispatch({type: SET_ZERO_INTRANET})
    dispatch({type: SET_ZERO_OFFER})
    dispatch({type: SET_ZERO_AKTIVITET})
    dispatch({type: SET_ZERO_ESIGNERING})
    dispatch({type: SET_ZERO_DASHBOARD})
    dispatch({type: SET_ZERO_ARENDE})
    dispatch({type: SET_ZERO_PROJECT})
    dispatch({type: SET_ZERO_OFFERT})
    dispatch({type: SET_ZERO_DIALER})
    dispatch({type: UNSET_AVTALVY_TYPE})
    dispatch({type: UNSET_ORDERVY_TYPE})
    dispatch({type: UNSET_EVENTVY_TYPE})
    dispatch({type: UNSET_ESIGNVY_TYPE})
    dispatch({type: UNSET_ARTIKLARVY_TYPE})
    callBackFunc()    
  }
}


